import React from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal } from 'antd';

type Props = {
  children: React.ReactChild;
  closeModal: () => void;
  isVisible: boolean;
  width: number;
  handleOk: () => void;
};
const ModalComponent = React.memo(
  ({ children, closeModal, isVisible, width, handleOk }: Props) => {
    const domE1 = document.getElementById('modal-root');

    if (!domE1) return null;

    const onSubmit = () => {
      closeModal();
      handleOk();
    };

    const handleCancel = () => {
      closeModal();
    };

    return ReactDOM.createPortal(
      <Modal
        style={{ top: '70px' }}
        width={width}
        visible={isVisible}
        className="ModalConfirmation"
        footer={[
          <Button onClick={handleCancel} className="back" key="back">
            {'Back'}
          </Button>,
          <Button
            onClick={onSubmit}
            className="confirm"
            key="submit"
            type="primary"
          >
            {'Send'}
          </Button>
        ]}
      >
        {children}
      </Modal>,
      domE1
    );
  }
);

export default ModalComponent;
